import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ErrorReporter } from '@core/services/error-reporter.service';

/** Angular's ErrorHandler (the same console output), and then the {@link ErrorReporter}. */
@Injectable()
export class AppErrorHandler extends ErrorHandler {
  private readonly reporter = inject(ErrorReporter);

  override handleError(error: unknown): void {
    super.handleError(error);
    this.reporter.report(error, { source: 'runtime' });
  }
}
